<ng-select
  [items]="agent$ | async"
  bindLabel="agent_name"
  [clearable]="true"
  [placeholder]="'CHOOSE_AGENT' | translate"
  [loading]="agentLoading"
  [trackByFn]="trackAgentByFn"
  [typeahead]="agentInput$"
  (change)="selectAgentChange($event)"
  [typeToSearchText]="'TYPE_TO_FIND_AN_AGENT' | translate"
  appendTo="body"
  style="position: relative"
>
  <ng-template ng-option-tmp let-item="item">
    <div class>
      <div class>
        <strong>{{ "USERNAME" | translate }} :</strong> {{ item.agent_name || "-" }}
      </div>
      <div class>
        <strong>{{ "NAME" | translate }} :</strong> {{ item.agent_contact_name || "-" }}
      </div>
      <div class>
        <strong>{{ "TYPE" | translate }} :</strong> {{ item.typeDetail || "-" }}
      </div>
      <div class>
        <strong>{{ "CREDIT" | translate }} :</strong>
        {{ item.credit_remaining || 0 | number : "0.2-2" }}
      </div>
    </div>
  </ng-template>
</ng-select>
